import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { SharedAssessmentListData } from "../../modules/user/self_assessment/type";
import { FeedbackListSliceProps } from "../../type";
import { get } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export const getSharedAssessmentListByMember = createAsyncThunk(
  "admin/assessment/shared",
  async (requestParams: FeedbackListSliceProps, storeActions) => {
    const url = `api/v1/admin/member/detail/self/assessment?memberId=${requestParams.memberId}&offSet=${requestParams.offSet}&count=${requestParams.count}`;
    const response: any = await get(url, storeActions);

    if (response.status === HttpStatus.OK) {
      return {
        status: HttpStatus.OK,
        data: await response.json(),
      };
    } else {
      return {
        status: response.status,
        text: await response.text(),
      };
    }
  }
);

const sharedAssessmentListByMemberSlice = createSlice({
  name: "sharedAssessmentListByMember",
  initialState: {
    status: null as number | null,
    loading: false as boolean,
    text: null as string | null,
    data: null as Array<SharedAssessmentListData> | null,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.text = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSharedAssessmentListByMember.fulfilled, (state, action) => {
      state.status = action.payload.status;
      state.loading = false;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.text = null;
      } else if (action.payload.text !== undefined) {
        state.data = null;
        state.text = action.payload.text;
      }
    });
    builder.addCase(getSharedAssessmentListByMember.pending, (state) => {
      state.status = null;
      state.loading = true;
      state.data = null;
      state.text = null;
    });
    builder.addCase(getSharedAssessmentListByMember.rejected, (state) => {
      state.status = 503;
      state.loading = false;
      state.data = null;
      state.text = null;
    });
  },
});

export const { clearData } = sharedAssessmentListByMemberSlice.actions;

export default sharedAssessmentListByMemberSlice;
